import { useQuery } from '@tanstack/react-query';

import { VideoCard } from './VideoCard';

import { useAuth } from '@/lib/auth/useAuth';
import { browseQueries } from '@/lib/queries/browse';

/**
 * Spec 34: the "continue watching" rail — the first personal element on the
 * browse surface. Mirrors VideoRow's structure exactly (same heading, same
 * Spec-32 responsive grid) and reuses VideoCard unmodified but for a progress
 * bar, so the freemium gate / lock chip / upgrade routing come along for free.
 * Owns its own query and self-hides when empty (anon or nothing in progress),
 * so the browse page stays byte-identical for everyone else.
 */
export function ContinueWatchingRow() {
  const { session } = useAuth();
  const { data: items = [] } = useQuery(browseQueries.continueWatching(session?.user.id));

  if (items.length === 0) return null;

  return (
    <section>
      <h2 className="font-sans text-sm font-medium uppercase tracking-[0.04em] text-video-text">
        Continue watching
      </h2>
      <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <VideoCard key={item.video.id} video={item.video} progressPercent={item.percent} />
        ))}
      </div>
    </section>
  );
}
